module.exports = __webpack_public_path__ + "img/lose.1cdc8387.png";